import 'core-js/modules/es6.set'; // react-dom
import 'core-js/modules/es6.map'; // react-dom
import 'intersection-observer';

export const onInitialClientRender = () => {
  // Don't preserve scroll position on reload or history change.
  window.scrollTo(0, 0);
};
